import { PositionWrapper, SeparatorDot, UnderlineText } from "./styles";
import { Trans, useTranslation } from "next-i18next";
import { Block, Box } from "../../../styles/basicStyles";
import { OpenSpot } from "../../../models/careers";
import { Element } from "react-scroll";
import { colors } from "../../../styles/colors";
import { FC } from "react";
import Typography from "../../../components/typography";
import Button from "../../../components/button";
import Dot from "../../../components/views/dot";
import Fade from "react-reveal/Fade";

interface OpenPositionsProps {
  positions: OpenSpot[];
}

const OpenPositions: FC<OpenPositionsProps> = ({ positions }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return (
    <>
      <Element name="positions" className="element" />
      <Box mb={{ md: 7.063, xxs: 3.938 }} fDirection="column">
        <Typography
          as='h2'
          fSize={{ md: 2.5, xxs: 1.813 }}
          lHeight={{ md: 3, xxs: 2.375 }}
          fWeight={700}
          style={{ color: colors.black }}
        >
          {t("OPEN_POSITIONS")}
          <Dot
            w={{ md: 0.875, xxs: 0.5 }}
            h={{ md: 0.875, xxs: 0.5 }}
            ml={0.375}
          />
        </Typography>
        <Typography
          fSize={{ md: 1.375, xxs: 1.063 }}
          lHeight={1.875}
          fWeight={400}
          style={{ color: colors.black07 }}
          mt={{ md: 1, xxs: 0.875 }}
        >
          {t("JOIN_OUR_TEAM")}
        </Typography>
        <Typography
          fSize={{ md: 1.375, xxs: 1.063 }}
          lHeight={1.875}
          fWeight={400}
          style={{ color: colors.black07 }}
        >
          <Trans
            i18nKey="OPEN_POSITIONS_DESCRIPTION"
            components={{
              Link: <UnderlineText href="mailto:info@codepoint.pt" />,
            }}
          />
        </Typography>
        <Box mt={{ md: 2.813, xxs: 1.938 }} fDirection="column">
          {positions.map((e, index) => (
            <PositionWrapper key={index} padding={{ md: 1.75, xxs: 1.438 }}>
              <Fade left>
                <Box
                  fDirection={{ md: "row", xxs: "column" }}
                  fJustify="space-between"
                  fAlign={{ md: "center", xxs: "flex-start" }}
                >
                  <Block
                    display="flex"
                    fJustify="space-between"
                    fDirection="column"
                  >
                    <Typography
                      fSize={{ md: 1.688, xxs: 1.5 }}
                      lHeight={{ md: 2, xxs: 1.75 }}
                      fWeight={700}
                      style={{ color: colors.black }}
                    >
                      {e.title[language]}
                    </Typography>
                    {e.tags && (
                      <Block mt={0.625} w={{ md: 20, xxs: "100%" }}>
                        {e?.tags.map((t, index) => (
                          <Typography
                            key={index}
                            fSize={{ md: 1.125, xxs: 1 }}
                            lHeight={{ md: 1.375, xxs: 1.188 }}
                            fWeight={400}
                            style={{ color: '#5344AB' }}
                            wSpace="nowrap"
                          >
                            {t}
                            {e.tags.length > 1 && index !== e.tags.length - 1 ? (
                              <SeparatorDot color='#5344AB' />
                            ) : null}
                          </Typography>
                        ))}
                      </Block>
                    )}
                  </Block>
                  <Typography
                    fSize={{ md: 1.125, xxs: 1 }}
                    lHeight={1.813}
                    fWeight={400}
                    style={{ color: 'rgba(23, 23, 23, 0.73)' }}
                    maxW={{ md: 22.75, xxs: "100%" }}
                    mt={{ md: 0, xxs: 0.75 }}
                    dangerouslySetInnerHTML={{ __html: e.description[language] }}
                  />
                  <Button
                    mt={{ md: 0, xxs: 1.5 }}
                    text={t("APPLY")}
                    variant="primary"
                    textColor={colors.white}
                    bgColor={colors.black}
                    onClick={() => window.open(e.link, '_blank')}
                  />
                </Box>
              </Fade>
            </PositionWrapper>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default OpenPositions;
